import { render, staticRenderFns } from "./share-report-dialog.vue?vue&type=template&id=5bc03a08&scoped=true&"
import script from "./share-report-dialog.vue?vue&type=script&lang=ts&"
export * from "./share-report-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./share-report-dialog.vue?vue&type=style&index=0&id=5bc03a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc03a08",
  null
  
)

export default component.exports